/**
 * Переход аккаунта `onboarding → active`.
 *
 * Синхронизация (CC §4.3 шаги 4–7) запускается только для активного аккаунта:
 * в `onboarding` сервер отвечает 403 `onboarding_incomplete` на `/sync/snapshot`,
 * списки и WebSocket (BS §5.7). `refreshMe` сообщает о переходе сюда, а не в
 * bootstrap напрямую — иначе `refresh-me ↔ bootstrap` образуют цикл модулей.
 */
import type { Me } from '@shared/api/types'

type ActivationListener = (me: Me) => void

let listener: ActivationListener | null = null

export function setActivationListener(next: ActivationListener | null): void {
  listener = next
}

export function notifyAccountActivated(me: Me): void {
  listener?.(me)
}
